import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/app", { replace: true });
      return;
    }

    (async () => {
      try {
        const resp = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!resp.ok) throw new Error("Auth failed");
        const user = await resp.json();
        // Clear hash and redirect to app with user data
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user } });
      } catch {
        navigate("/app", { replace: true });
      }
    })();
  }, [navigate]);

  return null;
};
